
const digest = '1424c7ee77c05f5fdc058f67bc5e77291f75cccb08c3ff3d9d7f69ca22c3526e';
const classes = {"controls":"_controls_nfj8j_1","button":"_button_nfj8j_8","description":"_description_nfj8j_12"};
const css = `._controls_nfj8j_1 {
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
  margin-top: 35px;
}
._controls_nfj8j_1 ._button_nfj8j_8 {
  width: fit-content;
}

._description_nfj8j_12 {
  color: #d81616;
  max-width: 550px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  